var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _c(
            "w-dropdown",
            {
              attrs: { items: _vm.dropdownItems, flat: "", right: "", sm: "" },
              on: {
                click: function ($event) {
                  return $event()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "bars" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-sortable",
        {
          attrs: { tag: "w-list", "target-class": "handle", items: _vm.items },
          on: {
            drop: function ($event) {
              return _vm.updateValue()
            },
          },
        },
        _vm._l(_vm.items, function (item) {
          return _c(
            "w-list-item",
            { key: item.value, attrs: { "show-handle": "" } },
            [
              _c("w-list-item-text", [_vm._v(" " + _vm._s(item.text) + " ")]),
              _c(
                "w-list-item-action",
                [
                  _c("w-checkbox", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("show-item"),
                        expression: "$ct('show-item')",
                      },
                    ],
                    attrs: { value: !item.disabled },
                    on: {
                      click: function ($event) {
                        return _vm.toggleDisabled(item)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }